import {
  Briefcase,
  Laptop,
  Users,
  Award,
  FolderKanban,
  GraduationCap,
  BadgeCheck,
  Headphones,
} from "lucide-react";

function WhyChoose() {
  const features = [
    {
      icon: <Laptop size={38} />,
      title: "Industry-Focused Curriculum",
      desc: "Learn the latest technologies and practical skills demanded by today's digital industry.",
    },
    {
      icon: <Users size={38} />,
      title: "Expert Mentor Support",
      desc: "Learn directly from experienced mentors with personalized guidance.",
    },
    {
      icon: <BadgeCheck size={38} />,
      title: "Certification",
      desc: "Receive a professional course completion certificate after successful training.",
    },
    {
      icon: <Award size={38} />,
      title: "Career Guidance",
      desc: "Resume building, interview preparation, and freelancing support for every learner.",
    },
  ];

  return (
    <section
      id="benefits"
      className="py-24 bg-gradient-to-br from-white via-blue-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-16">

          <span className="bg-blue-100 text-blue-700 px-5 py-2 rounded-full font-semibold">
            Why Choose Us
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold mt-6 text-gray-900">
            Why Choose
            <span className="text-blue-700">
              {" "}Digital with Priyanshi?
            </span>
          </h2>

          <p className="text-gray-600 mt-5 max-w-3xl mx-auto leading-8">
            We don't just teach technology—we prepare you for real careers,
            freelancing opportunities, and business success through practical,
            industry-oriented learning.
          </p>

        </div>

        {/* Cards */}

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">

          {features.map((item, index) => (

            <div
              key={index}
              className="group bg-white rounded-3xl p-8 shadow-md hover:shadow-2xl border border-blue-100 hover:border-blue-600 transition-all duration-300 hover:-translate-y-3"
            >

              <div className="w-16 h-16 rounded-2xl bg-blue-100 text-blue-700 flex items-center justify-center group-hover:bg-blue-700 group-hover:text-white transition duration-300">

                {item.icon}

              </div>

              <h3 className="mt-6 text-xl font-bold text-gray-900">
                {item.title}
              </h3>

              <p className="mt-4 text-gray-600 leading-7">
                {item.desc}
              </p>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}

export default WhyChoose;